<template>
  <div>
    <b-overlay
      :show="loading"
      no-wrap
    ></b-overlay>

    <p
      class="text-danger"
      v-if="error"
      >{{ errorMsg }}</p
    >

    <div class="row spl-inline-form">
      <div class="col-6">
        <hot-edit-input
          label="Item Name"
          v-model="itemData.name"
          :edit-mode="localEditMode"
          no-edit-class="font-weight-bold"
          ref="name"
          autofocus
          @blur="handleBlur"
        ></hot-edit-input>
      </div>

      <div class="col-6">
        <hot-edit-select
          label="Item Category"
          v-model="itemData.category"
          :edit-mode="localEditMode"
          :options="allCategories"
          value-field="id"
          text-field="name"
          ref="category"
          @blur="handleBlur"
        ></hot-edit-select>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-12">
                <hr>
            </div> -->

      <div class="col-6">
        <!-- <hot-edit-input
                    v-if="itemData.is_saved"
                    label="Item ID"
                    :value="itemData.id"
                    no-edit
                ></hot-edit-input> -->

        <hr />

        <hot-edit-input
          label="Part Number"
          v-model="itemData.part_number"
          :edit-mode="localEditMode"
          ref="part_number"
          class="mb-2"
          @blur="handleBlur"
        ></hot-edit-input>

        <hot-edit-input
          label="OEM Part Name"
          v-model="itemData.oem_part_name"
          :edit-mode="localEditMode"
          ref="oem_part_name"
          class=""
          @blur="handleBlur"
        ></hot-edit-input>

        <hot-edit-input
          label="OEM Part Number"
          v-model="itemData.oem_part_number"
          :edit-mode="localEditMode"
          ref="oem_part_number"
          class="mb-2"
          @blur="handleBlur"
        ></hot-edit-input>

        <hot-edit-input
          label="Manufacturer Part Number"
          v-model="itemData.mfg_part_number"
          :edit-mode="localEditMode"
          ref="mfg_part_number"
          class="mb-2"
          @blur="handleBlur"
        ></hot-edit-input>

        <!-- <template>
          <hot-edit-select
            label="Item Category"
            v-model="itemData.category"
            :edit-mode="localEditMode"
            :options="allCategories"
            value-field="id"
            text-field="name"
            ref="category"
            class="mb-3"
            @blur="handleBlur"
          ></hot-edit-select>
        </template> -->

        <hr />

        <!-- KEEPING erp_code and plm_code always read-only for now -->
        <hot-edit-input
          label="ERP Item ID"
          v-model="itemData.erp_code"
          :edit-mode="false"
          ref="erp_code"
          popover-content="This is the unique ID for this item in the ERP system. Optional."
          class="mb-2"
          @blur="handleBlur"
        ></hot-edit-input>

        <hot-edit-input
          label="PLM Item ID"
          v-model="itemData.plm_code"
          :edit-mode="false"
          ref="plm_code"
          class="mb-2"
          popover-content="This is the unique ID for this item in the PLM system. Optional."
          @blur="handleBlur"
        ></hot-edit-input>

        <!-- <hot-edit-textarea
          label="Description"
          v-model="itemData.description"
          :edit-mode="localEditMode"
          empty-text="---"
          rows="5"
          ref="description"
          @blur="handleBlur"
        ></hot-edit-textarea> -->
      </div>

      <div class="col-6">
        <hr />

        <hot-edit-textarea
          label="Description"
          v-model="itemData.description"
          :edit-mode="localEditMode"
          empty-text="---"
          rows="5"
          ref="description"
          @blur="handleBlur"
        ></hot-edit-textarea>

        <hr />

        <hot-edit-money
          label="Target Price"
          v-bind:amount.sync="itemData.target_price"
          v-bind:currency.sync="itemData.target_price_currency"
          :currency-options="currencyOptions"
          :edit-mode="localEditMode"
          ref="targetPrice"
          class="mb-2"
          @blur="handleBlur"
        ></hot-edit-money>

        <hot-edit-money
          label="Current Price"
          v-bind:amount.sync="itemData.current_price"
          v-bind:currency.sync="itemData.current_price_currency"
          :currency-options="currencyOptions"
          :edit-mode="localEditMode"
          ref="currentPrice"
          class="mb-2"
          @blur="handleBlur"
        ></hot-edit-money>

        <hot-edit-input
          label="Unit of Measure"
          v-model="itemData.uom_temp"
          :edit-mode="localEditMode"
          ref="uom"
          class="mb-0"
          @blur="handleBlur"
        ></hot-edit-input>
      </div>

      <div v-if="dynamicTaggingEnabled" class="col-12">
        <hr />
        <TagFields
          v-model="itemData.taggings_by_field"
          :config="taggingConfig"
          :isEditing="localEditMode"
          class="my-4"
        />
      </div>

      <div class="col-12 text-center pt-3">
        <b-form-checkbox
          v-if="createNew && !hideSaveCheckbox"
          id="checkbox-save-item"
          v-model="itemData.is_saved"
          name="checkbox-save-item"
        >
          Save item to Sourcing Item database
        </b-form-checkbox>

        <div
          v-if="!createNew && !itemData.is_saved"
          class="text-muted"
        >
          Item is not saved to Sourcing Item database.
        </div>
      </div>

      <div
        v-if="canShowErrors && (!allRefsValid || !hasNameOrPartNumber)"
        class="py-3 px-4"
      >
        <h6 class="text-danger">Please fix these errors:</h6>
        <p
          v-for="message in refsInvalidList"
          :key="message"
          class="text-danger mb-1 small"
        >
          {{ message }}
        </p>
        <p
          v-if="!hasNameOrPartNumber"
          class="text-danger mb-1 small"
        >
          Must provide at least item Name or Part Number
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { suppliosApi } from '@/js/api-service';
  import { errorHandling, tenantInfoMixin } from '@/js/custom-vue-mixins';
  import { HotEditInput, HotEditSelect, HotEditTextarea, HotEditMoney } from '@/js/custom-form-components';
  import merge from 'lodash/merge';
  import omit from 'lodash/omit';
  import isEmpty from 'lodash/isEmpty';
  import cloneDeep from 'lodash/cloneDeep';
  import TagFields from '@/components/taxonomy/taggings/TagFields.vue';

  export default {
    name: 'ProductDetailForm',
    components: {
      HotEditInput,
      HotEditSelect,
      HotEditTextarea,
      //HotEditSwitch,
      HotEditMoney,
      TagFields,
    },
    mixins: [errorHandling, tenantInfoMixin],
    props: {
      itemPk: {
        type: [Number, String],
        required: false,
      },
      editMode: {
        // set to TRUE if/when you want to force to edit mode on mount, managed locally through localEditMode
        // ideally you should call methods enterEditMode() and cancelEditMode() from parent
        type: Boolean,
        default: false,
      },
      createNew: {
        // set this to true if using this to create new, not edit existing
        // if this is true, then itemPk prop and editMode will be IGNORED
        type: Boolean,
        default: false,
      },
      newData: {
        // if you want to FORCE any field values for CREATE NEW objects (not update existing), pass it in here
        // fields must be in same format/names as used in API
        type: Object,
        required: false,
      },
      noRefreshOnUpdate: {
        // if you set this (to true) then it will not re-fetch updated object after update...
        // you SHOULD set this to true if you're embedding this in a modal or something else that will close the form after update
        type: Boolean,
        default: false,
      },
      hideSaveCheckbox: {
        // if true, we hide the 'save to item db' checkbox so it is always saved - useful for most create forms
        type: Boolean,
        default: false,
      },
      // currencyOptions: {  // array of strings with 3-digit currency choices, you can do more custom text/labels later
      //     type: Array,
      //     default: function() {
      //         return ['USD', 'EUR', 'GBP', 'DKK', 'CNY']
      //     }
      // },
    },
    data: function () {
      return {
        error: false,
        errorMsg: 'There was an error',
        loading: false,
        localEditMode: this.editMode, // localEditMode controls things, but this allows parent to force edit mode on create/mount
        // options for working with this object:
        // 1) Explicitly declare all the properties here so they are reactive
        // 2) use this.$set(this.itemData, 'newProp' when you fetch things from API
        // 3) use object generator or Object.assign({}, this.itemData, itemDataFromApi)... new ItemData both here and when you load stuff from API
        itemData: {},
        itemDataBeforeEdits: {},
        blankItemData: {
          name: '',
          description: '',
          part_number: '',
          oem_part_name: '',  // potentially hidden if Tenant does not use it?
          oem_part_number: '',  // potentially hidden if Tenant does not use it
          mfg_part_number: '',  // potentially hidden if Tenant does not use it
          erp_code: '',  // read-only for now though
          plm_code: '',  // read-only for now though
          created: null,
          modified: null,
          //is_compliant_temp: false,
          uom_temp: '',
          target_price: null,
          target_price_currency: '',
          current_price: null,
          current_price_currency: '',
          category: null,
          is_active: true, // keep?
          is_saved: true, // keep?
          taggings_by_field: {},
        },
        allCategories: [],
        allRefsValid: true, // set true initially... then false if any invalid found when checking, this is used as flag to show refsInvalid
        refsInvalidList: [], // set this in checkRefsValid()
        anyInputBlur: false, // set true on any @blur, basically just a dirty tracker
      };
    },
    computed: {
      currencyOptions() {
        return this.$tenantInfo.settings?.currency_settings?.currencyChoices ?? ['USD', 'EUR', 'GBP', 'DKK', 'CNY'];
      },
      hasNameOrPartNumber() {
        return !!(this.itemData.name || this.itemData.part_number);
      },
      canShowErrors() {
        return this.localEditMode && this.anyInputBlur; // and form is dirty?
      },
      dynamicTaggingEnabled() {
        return this.$getTenantFlag('taxonomy_product_tags', false);
      },
      taggingConfig() {
        return {
          modelLabel: 'items.Product',
          objectId: this.itemPk,  // should we ignore itemPk if createNew is true? maybe... but should that even happen?
          useInternalEdit: false,
        }
      },
    },
    created: function () {
      this.itemData = merge({}, this.blankItemData);
      if (this.createNew) {
        if (!isEmpty(this.newData)) {
          this.itemData = merge({}, this.itemData, this.newData);
        }
        this.enterEditMode();
        this.getAllCategories();
      } else {
        this.getItemData();
        this.getAllCategories();
      }
    },
    methods: {
      /* checkInvalidMessage: function() {
            // just for testing!
            console.log('hello from top level check validity');
            const refsToCheck = ['name', 'number', 'description', 'category', 'uom', 'targetPrice'];
            let errorMsgArray = [];
            refsToCheck.forEach(ref => {
                let fullRef = this.$refs[ref];
                console.log('checking the ref below:');
                console.log(fullRef);
                let errorMsg = fullRef.checkInvalidMessage();
                console.log(errorMsg);
                if (errorMsg) {
                    errorMsgArray.push(errorMsg);
                }
            });
            this.refsErrorMsgArray = errorMsgArray;
        }, */
      handleError: function (error, message) {
        console.log(message);
        console.log(error);
        if (Array.isArray(message)) {
          this.errorMsg = message.join(', ');
        } else {
          this.errorMsg = message;
        }
        this.error = true;
      },
      objectToArray: function (content) {
        // used to take returned error objects and output them to array of strings
        let outputArray = [];
        if (Object.keys(content).length) {
          // check if content has keys (is an object, really)
          for (const [key, value] of Object.entries(content)) {
            outputArray.push(`${key}: ${value}`);
          }
        } else if (Array.isArray(content)) {
          outputArray = [...content];
        } else {
          outputArray = [content];
        }
        return outputArray;
      },
      getAllCategories: function () {
        this.loading = true;
        suppliosApi.productCategory
          .list()
          .then((response) => {
            this.allCategories = response.data;
          })
          .catch((error) => {
            //this.handleError(error, 'Error during getAllCategories');
            this.apiErrorHandler(error, 'Error getting categories');
          })
          .then(() => {
            this.loading = false;
          });
      },
      getItemData: function () {
        this.loading = true;
        suppliosApi.item
          .retrieve(this.itemPk)
          .then((response) => {
            const itemDataResponse = response.data;
            this.itemData = merge({}, this.itemData, itemDataResponse);
          })
          .catch((error) => {
            //this.handleError(error, 'Error during getItemData');
            this.apiErrorHandler(error, 'Error getting item data');
          })
          .then(() => {
            this.loading = false;
            //this.localEditMode = false;
          });
      },
      formatDataForSave: function () {
        // grabs current data from this.itemData (cloneDeep), picks off only the fields you want to send to API in the correct format / field names
        //let fields_to_save = ['fname', 'lname', '_email', 'job_title', 'company'];
        const omitFields = ['erp_code', 'plm_code'];  // these are read-only for now, so we don't send them back to API
        let snapshotData = cloneDeep(this.itemData);
        const returnObj = omit(snapshotData, omitFields);  // there ARE nested things, so we must cloneDeep, don't just copy shallow and omit as you iterate
        return returnObj;
      },
      resetRefsValid: function () {
        // resets all refs you checked to default validation state so things aren't always in red outline if validation problems
        let allRefs = Object.values(this.$refs);
        allRefs.forEach((ref) => {
          if (ref && Object.keys(ref).includes('resetValidity')) {
            // have to check if refs are actually present and if they have resetValidity method
            ref.resetValidity(); // do the reset
          }
        });
      },
      checkRefsValid: function () {
        let allRefs = Object.values(this.$refs); // this.$refs is an object, Object.values() makes an array of actual refs
        let refsInvalidList = []; // we'll make this below... a list of errors from checking refs
        let allRefsValid = true; // set it to true here, then set to false if you find any invalid in loop below
        allRefs.forEach((ref) => {
          if (ref) {
            // have to check if refs are actually present
            let refKeys = Object.keys(ref);
            if (refKeys.includes('checkValidity')) {
              let isRefValid = ref.checkValidity();
              if (isRefValid === false) {
                // need to specifically check if 'false' -- because some hot-edit-inputs return 'null' if they aren't in edit mode, we'll ignore those
                refsInvalidList.push(ref.checkInvalidMessage());
                allRefsValid = false;
              }
            }
          }
        });
        this.refsInvalidList = refsInvalidList;
        this.allRefsValid = allRefsValid;
        const otherChecksOk = this.hasNameOrPartNumber; // add others if needed...
        return allRefsValid && otherChecksOk; // returns a Boolean
      },
      updateItemData: function () {
        // only used when editing existing item (not saving new)
        if (!this.checkRefsValid()) return Promise.resolve(false);
        this.loading = true;
        let updateObject = this.formatDataForSave();
        const updateItemPromise = suppliosApi.item
          .partialUpdate(this.itemPk, updateObject)
          .then((response) => {
            this.$emit('update-complete', response.data);
            console.log(response);
            this.$toast.success('Item successfully updated');
            if (!this.noRefreshOnUpdate) {
              this.getItemData();
            }
            this.exitEditMode();
          })
          .catch((error) => {
            // if you have error, keep the form open and in edit mode, showing errors, allowing user to correct things
            //this.handleError(error, this.objectToArray(error.response.data));  // error will likely be an object with key = field name and value = error message
            this.apiErrorHandler(error);
          })
          .finally(() => {
            this.loading = false;
          });
        return updateItemPromise;
      },
      saveNewItem: function () {
        // only used when saving new item (not editing existing)
        if (!this.checkRefsValid()) return Promise.resolve(false);
        this.loading = true;
        let saveObject = this.formatDataForSave();
        const saveItemPromise = suppliosApi.item
          .create(saveObject)
          .then((response) => {
            this.$emit('save-complete', response.data);
            console.log(response);
            this.$toast.success('Item successfully added');
          })
          .catch((error) => {
            //this.handleError(error, this.objectToArray(error.response.data));
            this.apiErrorHandler(error);
          })
          .finally(() => {
            this.loading = false;
          });
        return saveItemPromise;
      },
      clearErrors: function () {
        // call this at least when exiting editMode because you're resetting values anyways
        this.error = false;
        this.resetRefsValid(); // set all refs to their default validation visible state
        this.allRefsValid = true;
        this.refsInvalidList = [];
      },
      enterEditMode: function () {
        this.itemDataBeforeEdits = cloneDeep(this.itemData); // store this so you have it if you edit then cancel
        this.localEditMode = true;
        this.anyInputBlur = false;
        this.$emit('edit-on');
      },
      cancelEditMode: function () {
        this.itemData = cloneDeep(this.itemDataBeforeEdits);
        this.localEditMode = false;
        this.clearErrors();
        this.$emit('edit-off');
      },
      exitEditMode: function () {
        // exit edit mode, but don't reset item data
        this.localEditMode = false;
        this.$emit('edit-off');
      },
      handleBlur() {
        // any input @blur event calls this -- for now just set anyInputBlur=true
        this.anyInputBlur = true;
      },
    },
  };
</script>

<style></style>
